import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import styled from "styled-components";
import { Marginer } from "../components/marginer";
import { deviceSize } from "../components/responsive";
import TopSectionBackgroundImg from "../img/AODG26844.png";

const TopSectionContainer = styled.div`

width:100%;

min-height:700px;

background:

linear-gradient(
135deg,
rgba(2,6,23,.96),
rgba(8,26,47,.92)
);

padding:80px 20px;

`;



const BackgroundFilter = styled.div`

width:100%;

height:100%;

display:flex;

flex-direction:column;

`;

const Cards = styled.div`

display:grid;

grid-template-columns:

repeat(4,1fr);


gap:25px;


max-width:1300px;

margin:auto;



@media(max-width:1000px){

grid-template-columns:repeat(2,1fr);

}



@media(max-width:600px){

grid-template-columns:1fr;

}
`;
const Title = styled.h1`

color:white;

font-size:

clamp(2rem,5vw,3.5rem);

font-weight:900;

text-align:center;

margin-bottom:50px;


text-shadow:

0 0 25px rgba(56,189,248,.5);



p:first-child{

margin-bottom:10px;

}



&::after{

content:"";

display:block;

width:90px;

height:4px;

background:#38bdf8;

margin:20px auto;

border-radius:20px;

box-shadow:

0 0 20px #38bdf8;

}








`;



const CardBox = styled.div`

padding:35px 25px;

border-radius:30px;


background:

rgba(255,255,255,.08);


backdrop-filter:blur(20px);



border:

1px solid rgba(255,255,255,.15);



box-shadow:

0 25px 60px rgba(0,0,0,.45);



color:white;

text-align:center;


transition:.3s;



&:hover{

transform:translateY(-10px);


box-shadow:

0 0 40px rgba(56,189,248,.35);

}


h3{

font-size:24px;

font-weight:900;

}



p{

color:#e2e8f0;

line-height:1.8;

}


`;





const ContactButton = styled.a`

display:inline-flex;

justify-content:center;

align-items:center;


padding:14px 25px;


border-radius:50px;


background:

linear-gradient(
135deg,
#0ea5e9,
#2563eb
);


color:white;


font-weight:900;


text-decoration:none;


margin-top:15px;


box-shadow:

0 10px 30px rgba(37,99,235,.4);



transition:.3s;



&:hover{

transform:translateY(-3px);

}

`;


export function TopSection3() {
  // 🔥 שעון חי
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const hour = now.getHours();
  const minute = now.getMinutes();
  const day = now.getDay();

  const currentTime = hour * 60 + minute;

  const toMinutes = (h, m) => h * 60 + m;

  // שעות
  const weekdayOpen = toMinutes(8, 0);
  const weekdayClose = toMinutes(18, 30);

  const fridayOpen = toMinutes(8, 0);
  const fridayClose = toMinutes(13, 0);

  // ימים
  const isWeekday = day >= 0 && day <= 4;
  const isFriday = day === 5;

  let isOpen = false;

  if (isWeekday) {
    isOpen =
      currentTime >= weekdayOpen &&
      currentTime < weekdayClose;
  } else if (isFriday) {
    isOpen =
      currentTime >= fridayOpen &&
      currentTime < fridayClose;
  }

  // 🔥 טקסט "ייפתח בעוד..."
  const getNextOpenMessage = () => {
    const weekdayOpen = toMinutes(8, 0);
    const weekdayClose = toMinutes(18, 30);
    const fridayOpen = toMinutes(8, 0);
    const fridayClose = toMinutes(13, 0);

    if (isWeekday) {
      if (currentTime < weekdayOpen) {
        const diff = weekdayOpen - currentTime;
        return `ייפתח בעוד ${Math.floor(diff / 60)} שעות ו-${diff % 60} דקות`;
      }

      if (currentTime >= weekdayClose) {
        return "סגור היום – ייפתח מחר ב־08:00";
      }
    }

    if (isFriday) {
      if (currentTime < fridayOpen) {
        const diff = fridayOpen - currentTime;
        return `ייפתח בעוד ${Math.floor(diff / 60)} שעות ו-${diff % 60} דקות`;
      }

      if (currentTime >= fridayClose) {
        return "סגור – ייפתח בראשון ב־08:00";
      }
    }

    if (day === 6) {
      return "סגור – ייפתח בראשון ב־08:00";
    }

    return "";
  };

return (
  <TopSectionContainer>

    <BackgroundFilter>

      <div id="con">

        <Title>
          <p>צור קשר</p>
          <p>אנחנו זמינים בשבילך בכל שאלה</p>
        </Title>


        <Cards>


          <CardBox>

            <h3>📞 טלפון</h3>

            <p>
              050-6978865
            </p>

            <ContactButton href="tel:0506978865">
              חייג עכשיו
            </ContactButton>

          </CardBox>




          <CardBox>

            <h3>📧 אימייל</h3>

            <p>
              s.g.one2021@gmail.com
            </p>


            <ContactButton
              target="_blank"
              href="https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=s.g.one2021@gmail.com"
            >

              שלח מייל

            </ContactButton>


          </CardBox>





          <CardBox>

            <h3>📍 משרדנו</h3>


            <p>
              מבצע הדקל 14 פתח תקווה
            </p>


            <ContactButton

              target="_blank"

              href="https://www.google.com/maps?q=מבצע הדקל 14 פתח תקווה"

            >

              פתח במפה

            </ContactButton>


          </CardBox>






          <CardBox>


            <h3>
              🕒 שעות פעילות
            </h3>


            <p>

              {hour}:{String(minute).padStart(2,"0")}

            </p>



            <ul className="hours">

     <p style={{
  lineHeight:"2",
  textAlign:"center",
  direction:"rtl"
}}>

🟢 ראשון - חמישי: 08:00 - 18:30
<br/>

🟢 שישי: 08:00 - 13:00
<br/>

🔴 שבת: סגור

</p>




            </ul>




            <span
              className={
                `status ${isOpen ? "open":"closed"}`
              }
            >

              ● {isOpen ? "פתוח עכשיו":"סגור עכשיו"}

            </span>



            {!isOpen && (

              <p>

                {getNextOpenMessage()}

              </p>

            )}


          </CardBox>



        </Cards>





      </div>


    </BackgroundFilter>


  </TopSectionContainer>
);
}